import { render, staticRenderFns } from "./TableSatuan.vue?vue&type=template&id=471b5720&"
import script from "./TableSatuan.vue?vue&type=script&lang=js&"
export * from "./TableSatuan.vue?vue&type=script&lang=js&"
import style0 from "./TableSatuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports